import { render, staticRenderFns } from "./GalleryCard.vue?vue&type=template&id=15db900d&scoped=true&"
import script from "./GalleryCard.vue?vue&type=script&lang=ts&"
export * from "./GalleryCard.vue?vue&type=script&lang=ts&"
import style0 from "./GalleryCard.vue?vue&type=style&index=0&id=15db900d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db900d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsImageOrFallback: require('/var/www/packages/theme/components/atoms/ImageOrFallback.vue').default,IconsArrowrightArrowRight24px: require('/var/www/packages/theme/components/icons/arrowright/ArrowRight24px.vue').default,MoleculesCmsUrlWrapper: require('/var/www/packages/theme/components/molecules/CmsUrlWrapper.vue').default})
